import * as $ from "jquery";

/**
 * IMPORTANT.
 * A modified version of this script can be found in the FlyAdmin `head.scala.html` file.
 * Whatever edits which are made in here should also be made in there.
 * /fly-admin/src/main/webapp/WEB-INF/twirl/com/garmin/fly/components/head.scala.html
 */

let hasAppendedBlocker = false;

function toggleMenu() {
	$(document.documentElement).toggleClass("is-menu-open");

	if (!hasAppendedBlocker) {
		$(document.body).append('<div class="header_blocker js-mobile-menu-toggle"></div>');
		hasAppendedBlocker = true;
	}
}

$(document).on("click", ".js-mobile-menu-toggle", toggleMenu);
